import React from "react"
import './src/styles/global.css';
import WrapRootElement from "./src/wrap-root-element"

export const wrapRootElement = ({ element }) => (
  <WrapRootElement>{element}</WrapRootElement>
)
